import { createContext, useContext, useEffect, useState } from "react";
import { api, API_BASE } from "./api";

const ThemeCtx = createContext({ theme: "light", toggle: () => {} });
const CompanyCtx = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem("smipl_theme") || "light");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("smipl_theme", theme);
  }, [theme]);
  return (
    <ThemeCtx.Provider value={{ theme, toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")), setTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
};
export const useTheme = () => useContext(ThemeCtx);

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const refresh = () => api.get("/config/company").then((r) => {
    setCompany(r.data);
    if (r.data.company_name) document.title = `${r.data.company_name}`;
  }).catch(() => setCompany({ company_name: "SMIPL CRM", tagline: "Enterprise Suite" }));
  useEffect(() => { refresh(); }, []);
  const logoUrl = company?.logo_file_id ? `${API_BASE}/config/company/logo?v=${company.logo_file_id}` : null;
  return <CompanyCtx.Provider value={{ company, refresh, logoUrl }}>{children}</CompanyCtx.Provider>;
};
export const useCompany = () => useContext(CompanyCtx);
